import { lazy } from 'react';
import { TabListClaimTracking } from 'src/compass/pages/endorsements/ClaimTrackingPage';

import { ICONS } from '../navigationIcons';
import { TabListToRouteList } from '../../util/TabListToRouteList';

const ScePage = lazy(() => import('src/compass/pages/endorsements/SceEntryPage'));
const SceOrdersPage = lazy(() => import('src/compass/pages/endorsements/SceOrdersPage'));
const LrpQuotesPage = lazy(() => import('src/compass/pages/endorsements/LrpQuotesPage'));
const ClaimTrackingPage = lazy(() => import('src/compass/pages/endorsements/ClaimTrackingPage'));

export const EndorsementsMenu = [
  {
    menuTitle: 'Endorsements',
    path: 'endorsements',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'SCE Entry',
        path: 'sce',
        element: <ScePage />,
        permission: 'SCEORDERS',
        hidden: true,
      },
      {
        title: 'SCE Orders',
        path: 'sceorders',
        element: <SceOrdersPage />,
        permission: 'SCEORDERS',
      },
      {
        title: 'LRP Quotes',
        path: 'lrpquotes',
        element: <LrpQuotesPage />,
        permission: 'LRP_QUOTES',
      },
      {
        title: 'Claim Tracking',
        path: 'claimtracking',
        element: <ClaimTrackingPage />,
        permission: 'CLAIM_TRACKING',
        children: TabListToRouteList(TabListClaimTracking)
      },
    ],
  },
];
